// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportAgentComponent_wrapper__dFby3"};